import erstTabsJson from './erstgespraech-tabs.json'
import avgsTabsJson from './avgs-tabs.json'
import bewilligungTabsJson from './bewilligung-tabs.json'
import vertragTabsJson from './vertrag-tabs.json'
import ecnTabsJson from './ecn-tabs.json'
import abschlussTabsJson from './abschluss-tabs.json'

import type { TabsConfig } from '@/core/templates/types'

export const erstgespraechTabs = (erstTabsJson as TabsConfig).tabs
export const avgsTabs = (avgsTabsJson as TabsConfig).tabs
export const bewilligungTabs = (bewilligungTabsJson as TabsConfig).tabs
export const vertragTabs = (vertragTabsJson as TabsConfig).tabs
export const ecnTabs = (ecnTabsJson as TabsConfig).tabs
export const abschlussTabs = (abschlussTabsJson as TabsConfig).tabs

export { default as avgsForm } from './avgs'
export { default as erstgespraechForm } from './erstgespraech-checkliste'
export { default as traegerbestaetigungForm } from './traegerbestaetigung'
export { default as bewilligungForm } from './bewilligung'
export { default as vertragForm } from './vertrag'
export { default as ecnForm } from './ecn'
export { default as massnahmeDetailsForm } from './massnahme-details'
export { default as abschlussberichtForm } from './abschlussbericht'
